import { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import { useClientSettings, accentClasses } from './settings';

const SPLASH_KEY = 'client-pwa-splash-shown';

export default function Splash() {
  const { settings, t } = useClientSettings();
  const [visible, setVisible] = useState(() => {
    try {
      return sessionStorage.getItem(SPLASH_KEY) !== '1';
    } catch {
      return true;
    }
  });

  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => dismiss(), 2400);
    return () => clearTimeout(timer);
  }, [visible]);

  const dismiss = () => {
    try { sessionStorage.setItem(SPLASH_KEY, '1'); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  const accent = accentClasses[settings.accent];

  return (
    <div
      onClick={dismiss}
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-between bg-gradient-to-br ${accent.gradient} px-8 pb-12 pt-20 text-white animate-in fade-in duration-500`}
    >
      <div className="flex flex-1 flex-col items-center justify-center text-center">
        <div className="mb-8 flex h-24 w-24 items-center justify-center rounded-3xl bg-white/15 shadow-xl shadow-black/20 backdrop-blur-sm">
          <span className="text-3xl font-bold">BA</span>
        </div>
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-white/70">
          Beacon Accounting
        </p>
        <h1 className="mt-4 text-3xl font-bold leading-tight">James Tiling Pty Ltd</h1>
        <p className="mt-2 text-sm text-white/80">Welcome to your client portal</p>
      </div>

      <div className="flex items-center gap-2 text-xs text-white/70">
        <span>{t('powered_by')}</span>
        <div className="flex items-center gap-1 rounded-full bg-white/15 px-3 py-1.5 backdrop-blur-sm">
          <Sparkles className="h-3 w-3" />
          <span className="font-semibold tracking-wide text-white">RoniDoc</span>
        </div>
      </div>
    </div>
  );
}
